export const crop = (str: string, count: number): string => {
  if (str.length > count) {
    return `${str.substring(0, count)}...`;
  }
  return str;
};
